// @ts-nocheck
/* tslint:disable */

// These function were shamelessly imported from tracking application
// as we couldn't figure out how the images were encoded

function decodeCognitoBitmap(txt, len) {
  var ptr = "";
  var ctr = 0,
    off = 0,
    i = 0;

  for (; ctr < len; ) /* Loop for all chars */ {
    var cur = txt.charCodeAt(ctr) - 128;
    var nxt = txt.charCodeAt(ctr + 1) - 128;
    var coff = cur >> off;
    var noff = (nxt << (7 - off)) & 255;
    var val = coff | noff;
    ptr += String.fromCharCode(val);
    ++i;
    ctr += off < 6 ? 1 : 2;
    off = off < 6 ? off + 1 : 0;
  }
  ctr = i; /* Size */
  var bmp = ptr;
  off = bmp.charCodeAt(10) - 62; /* Check for non-standard */
  if (off < 0)
    /* Offset too small */
    return -1;

  if (off > 0) {
    /* Non-standard structure */ /* Cut down to 62 */
    bmp.replace(
      2,
      String.fromCharCode(bmp.charCodeAt(2) - off)
    ); /* Reduce size */
    ctr -= off;

    bmp.replace(10, String.fromCharCode(bmp.charCodeAt(62))); /* Set to 62 */

    ptr = bmp.slice(0, 62);
    ptr += ptr + bmp.slice(0, 62 + off); /* Lose extra bytes */
  }

  return bmp;
}

export function decodeBase64Image(img) {
  var str = atob(img);
  var bmp = decodeCognitoBitmap(str, str.length);

  return "data:image/bmp;base64, " + btoa(bmp);
}
